import auth from './auth';
import brands from './brands';
import classifications from './classifications';
import classifier from './classifier';
import featureRules from './feature-rules';
import features from './features';
import global from './global';
import mappedValues from './mapped-values';
import matching from './matching';
import matchingItems from './matching-items';
import matchingItemsData from './matching-items-data';
import predictions from './predictions';
import sellers from './sellers';
import similar from './similar';
import taggedFeatures from './tagged-features';

export default {
  auth,
  brands,
  classifications,
  classifier,
  features,
  featureRules,
  global,
  mappedValues,
  matching,
  matchingItems,
  matchingItemsData,
  predictions,
  sellers,
  similar,
  taggedFeatures
}
